import Render from './render';
function draw(context, layout) {
    let paint = new Paint(context, layout), canvas = context.canvas;
    //重新设置cvs的尺寸.内容会清空,context会重置
    canvas.width = layout.width || 300;
    canvas.height = layout.height || 150;
    paint.draw();
}
class Paint {
    constructor(context, layout) {
        this.context = context;
        this.width = layout.width;
        this.height = layout.height;
        this.padding = layout.padding;
        this.radius = layout.radius || 0;
        this.bgColor = layout.bgColor || '#FFF';
        this.shapes = layout.shapes;
    }
    draw() {
        let ctx = this.context;
        ctx.save();
        this.drawBackground();
        ctx.restore();
        ctx.save();
        // 处理画布padding
        ctx.translate(this.padding[0], this.padding[1]);
        //绘画每个"部件"
        this.shapes.forEach(shape => {
            ctx.save();
            if (shape.drawBefore) {
                shape.drawBefore(this.context, shape, this.shapes);
            }
            let drawItem = new Render(this.context, shape);
            drawItem.draw();
            if (shape.drawAfter) {
                shape.drawAfter(this.context, shape, this.shapes);
            }
            ctx.restore();
        });
        ctx.restore();
    }
    drawBackground() {
        let ctx = this.context, r = this.radius, PI = Math.PI;
        if (r > 0) {
            ctx.moveTo(0, r);
            ctx.arc(r, r, r, PI, 1.5 * PI);
            ctx.lineTo(this.width - r, 0);
            ctx.arc(this.width - r, r, r, 1.5 * PI, 0);
            ctx.lineTo(this.width, this.height - r);
            ctx.arc(this.width - r, this.height - r, r, 0, 0.5 * PI);
            ctx.lineTo(r, this.height);
            ctx.arc(r, this.height - r, r, 0.5 * PI, PI);
            ctx.closePath();
            ctx.clip();
        }
        ctx.fillStyle = this.bgColor;
        ctx.fillRect(0, 0, this.width + 1, this.height + 1);
    }
}
export default draw;
